import React from 'react';
import I18n from 'i18n-js';
import UnitLessonSelect from '@/components/common/ModelSelect/UnitLessonSelect';
import * as Routes from '@/modules/routes';
import useGradesTableStore from './store/useGradesTableStore';

const Navigation = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const lesson = useGradesTableStore(state => state.lesson);
  const unit = useGradesTableStore(state => state.unit);
  const programId = useGradesTableStore(state => state.programId);
  const student = useGradesTableStore(state => state.student);

  const lessonSelectUrl = Routes.student_program_lesson_scores_path(programId, 'select_id');
  const unitSelectUrl = Routes.unit_scores_student_program_unit_scores_path(programId, 'select_id');

  return (
    <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
      <div>
        <p className="tw-text-[1.25rem] tw-font-bold tw-text-tci-black"> {student.first_name} {student.last_name} </p>
        <p className="tw-text-[1rem] tw-text-very-dark-grey">
          {lesson ? `${I18n.t('lesson')} ` : '' }
          {unit?.title || lesson?.title}
        </p>
        <p className="tw-text-very-dark-grey">
          <span className="tw-font-bold"> {I18n.t('class')}:  </span>
          {classroom.name}
        </p>
      </div>
      <div className="tw-bg-light-grey tw-pl-6 tw-pr-4 tw-pb-3 tw-rounded-lg tw-flex tw-items-center">
        {(lesson?.id || unit?.id) && (
          <UnitLessonSelect
            initialOption={{
              label: (unit || lesson).title,
              value: (unit || lesson).id,
            }}
            parentResourceUrl={unitSelectUrl}
            programId={programId}
            resourceUrl={lessonSelectUrl}
          />
        )}
      </div>
    </div>
  );
};

export default Navigation;
